import { Button, CCString, CCBoolean, _decorator } from 'cc';
import ButtonColorSet from '../../CCClass/ButtonColorSet';
import ButtonSpriteSet from '../../CCClass/ButtonSpriteSet';
import LocalizedButton from '../LocalizedComponent/LocalizedButton';
import MultiThemeComponent from './MultiThemeComponent';

enum EventType {
    CLICK = 'THEME_CLICK',
}

const { ccclass, property, requireComponent, menu } = _decorator;

@ccclass('MultiThemeButton')
@menu('MultiTheme/MultiThemeButton')
@requireComponent(Button)
export default class MultiThemeButton extends MultiThemeComponent<Button> {
    public static readonly EVENT_TYPE = EventType;

    @property
    private readonly updateButtonSpriteSets = true;

    @property({
        type: [ButtonSpriteSet],
        formerlySerializedAs: '_buttonSpriteSets',
        visible(this: MultiThemeButton) {
            return this.updateButtonSpriteSets;
        },
    })
    private readonly buttonSpriteSets: ButtonSpriteSet[] = [];

    @property
    private readonly updateButtonColorSets = false;

    @property({
        type: [ButtonColorSet],
        formerlySerializedAs: '_buttonColorSets',
        visible(this: MultiThemeButton) {
            return this.updateButtonColorSets;
        },
    })
    private readonly buttonColorSets: ButtonColorSet[] = [];

    @property
    private readonly updateButtonSpriteSetKeys = false;

    @property({
        type: [CCString],
        visible() {
            return this.updateButtonSpriteSetKeys;
        },
    })
    private readonly buttonSpriteSetKeys: string[] = [];

    @property
    private readonly updateButtonInteractable = false;

    @property({
        type: [CCBoolean],
        visible() {
            return this.updateButtonInteractable;
        },
    })
    private readonly buttonInteractable: boolean[] = [];

    private _localizedButton: LocalizedButton = null;

    private get localizedButton() {
        if (!this._localizedButton) {
            this._localizedButton = this.target.getComponent(LocalizedButton);
        }
        return this._localizedButton;
    }

    public getMaxTheme(): number {
        if (this.updateButtonSpriteSets) {
            return this.buttonSpriteSets.length;
        }
        if (this.updateButtonColorSets) {
            return this.buttonColorSets.length;
        }
        if (this.updateButtonSpriteSetKeys) {
            return this.buttonSpriteSetKeys.length;
        }
        if (this.updateButtonInteractable) {
            return this.buttonInteractable.length;
        }
        return 0;
    }

    protected onLoad() {
        super.onLoad();
        this.node.on(Button.EventType.CLICK, () => {
            this.emit(MultiThemeButton.EVENT_TYPE.CLICK, this.theme);
        });
    }

    protected getTarget() {
        return this.getComponent(Button);
    }

    protected onThemeChanged() {
        if (this.updateButtonSpriteSets) {
            this.buttonSpriteSets[this._theme].apply(this.target);
        }
        if (this.updateButtonColorSets) {
            this.buttonColorSets[this._theme].apply(this.target);
        }
        if (this.updateButtonSpriteSetKeys) {
            this.localizedButton.key = this.buttonSpriteSetKeys[this._theme];
        }
        if (this.updateButtonInteractable) {
            this.target.interactable = this.buttonInteractable[this._theme];
        }
    }
}
